import React, { memo } from "react";
import { MapsChart } from "investira.react.charts";

const RegiaoMapChart = memo((props) => {
  const { data = [], map = "brasilMap", title = {} } = props;

  const xOptions = {
    title: {
      ...title,
      style: {
        fontSize: "0.85rem",
      },
    },
    mapNavigation: {
      enabled: true, // Permite zoom e navegação no mapa
      buttonOptions: {
        verticalAlign: "bottom",
      },
    },
    colorAxis: {
      min: data[data.length - 1].value,
      max: data[0].value, // Define a escala de cores com base nos percentuais
      minColor: "#00dfa8", // Cor para o valor mínimo
      maxColor: "#ED442A", // Cor para o valor máximo
      labels: {
        style: {
          color: "#FFFFFF", // Cor do texto dos rótulos da escala
        },
        formatter: function () {
          // Personaliza os rótulos da legenda para sempre o menor valor
          if (this.value === 0) {
            return data[data.length - 1].value;
          }
          return this.value; // Exibe os outros valores
        },
      },
    },
    series: [
      {
        name: "Percentual",
        data: data,
        joinBy: "hc-key",
        nullColor: "#7a81ab",
        borderColor: "#2e2e46", // Cor de contorno dos estados
        borderWidth: 1, // Espessura da borda

        states: {
          hover: {
            color: "#1e90ff", // Cor ao passar o mouse
            borderColor: "#64eeff",
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function () {
            // Exibe o nome do estado apenas se houver dados
            return this.point.value ? this.point.name : null;
          },
          style: {
            color: "#333333", // Cor do texto
            fontSize: "10px", // Tamanho da fonte
            fontWeight: "bold", // Negrito
          },
        },
      },
    ],
    tooltip: {
      formatter: function () {
        // Formata o tooltip para exibir o valor percentual
        return `<b>${this.point.name}</b>`;
      },
    },
  };

  console.log(xOptions);
  return <MapsChart options={xOptions} map={map} />;
});

export default RegiaoMapChart;
